import { Link } from "react-router-dom";
import { WhatsApp } from "@/components/site/Brands";
import { FaqList } from "@/components/site/Blocks";
import LeadForm from "@/components/site/LeadForm";
import { HOME_FAQS } from "@/data/home";
import { waLink } from "@/data/site";

export default function FaqContact() {
  return (
    <section id="contatto" className="sec scroll-mt-20 bg-p-mist">
      <div className="wrap grid gap-12 lg:grid-cols-[1fr_1.1fr]">
        <div>
          <p className="eyebrow">FAQ</p>
          <h2 className="h-section mt-3">Domande rapide.</h2>
          <div className="mt-8"><FaqList faqs={HOME_FAQS} id="home-faq" /></div>
          <Link to="/prezzi" className="link-arrow mt-6">Tutte le condizioni nella pagina prezzi</Link>
        </div>
        <div className="bg-p-form relative overflow-hidden rounded-[2rem] border border-violet-100 p-6 shadow-[0_30px_60px_-40px_rgba(39,83,245,0.45)] sm:p-10 [&_.field]:border-slate-300">
          <h2 className="text-3xl font-bold leading-tight text-slate-900 sm:text-4xl">Raccontaci la tua attività. <span className="hl-light">Al resto pensiamo noi.</span></h2>
          <p className="mt-3 text-sm text-slate-600">Risposta entro un giorno lavorativo. Preventivo scritto, senza impegno.</p>
          <div className="mt-6"><LeadForm formType="preventivo" /></div>
          <a href={waLink("preventivo")} target="_blank" rel="noopener noreferrer" data-testid="home-contact-whatsapp" className="mt-6 inline-flex items-center gap-3 text-sm font-semibold text-slate-900 hover:text-blue-600"><WhatsApp size="h-8 w-8" icon="h-4 w-4" />Oppure scrivici su WhatsApp</a>
        </div>
      </div>
    </section>
  );
}
